// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundImage__background-ec6dd0 {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

@media (max-width: 428px) {
  .BackgroundImage__background-ec6dd0 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/Pages/Components/BackgroundImage/BackgroundImage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;AACF","sourcesContent":[".background {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n@media (max-width: 428px) {\n  .background {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `BackgroundImage__background-ec6dd0`
};
module.exports = ___CSS_LOADER_EXPORT___;
